import React, { createContext, useContext } from "react";

interface AnimatedBorderContextProps {
  isActive: boolean;
  isError?: boolean;
  setIsError: React.Dispatch<React.SetStateAction<boolean>>;
}

const AnimatedBorderContext = createContext<AnimatedBorderContextProps | undefined>(undefined);

export const useAnimatedBorderContext = () => {
  const context = useContext(AnimatedBorderContext);
  if (!context) {
    throw new Error("useAnimatedBorderContext must be used within an AnimatedGradientBorder");
  }

  return context;
};

// Safe version that returns null when context is not available
export const useAnimatedBorderContextSafe = () => {
  const context = useContext(AnimatedBorderContext);

  return context || null;
};

export const AnimatedBorderProvider = ({ children, isActive, isError: contextIsError }: { children: React.ReactNode; isActive: boolean; isError?: boolean }) => {
  const [isError, setIsError] = React.useState(contextIsError ?? false);

  return <AnimatedBorderContext.Provider value={{ isActive, isError, setIsError }}>{children}</AnimatedBorderContext.Provider>;
};
